import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';

export const heroBadges = ['The SIGMA SMART™ Method', 'Instant Access', 'Digital PDF', 'Mobile & Tablet Ready'];

export const heroWorkflows = ['Lead Generation', 'Listings', 'Lead Conversion', 'Objections', 'Follow-Up', 'Content', 'Authority'];

export const heroChips = [
  { icon: FileTextIcon, label: '100% Digital PDF & Mobile Access' },
  { icon: ZapIcon, label: 'Instant Download' },
  { icon: BotIcon, label: 'Works with ChatGPT, Claude, Gemini & other major AI assistants' },
  { icon: SmartphoneIcon, label: 'Optimized for Laptop, Tablet & Phone' },
];
